export default class LazyLoad {
  constructor( node ) {
    this.node = node;
    this.lazyloads = [ ...document.querySelectorAll( '.lozad' ) ];
    this.observers = [];
    /**
     * when we are using a jump navigation we have to disable the lazyload.
     * Otherwise the calculated scroll to position is wrong.
     */
    if ( document.querySelector( '.jump-navigation' )) {
      this.preloadImages();
    } else {
      this.setObserver();
    }
  }

  preloadImages() {
    for ( let lozad of this.lazyloads ) {
      this.setActive( lozad, false );
    }
  }

  setActive( node ) {
    let parent = node.parentElement;
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf( 'MSIE ' );

    switch ( node.tagName ) {
    case 'IMG': {
      node.src = node.getAttribute( 'data-src' );
      if ( parent.tagName === 'PICTURE' ) {
        let sources = parent.getElementsByTagName( 'SOURCE' );
        [ ...sources ].forEach(( source ) => {
          source.setAttribute( 'srcset', source.getAttribute( 'data-srcset' ));
        });
        if ( msie > 0 || !!navigator.userAgent.match( /Trident.*rv\:11\./ )) {
          node.src = sources[ 0 ].getAttribute( 'data-srcset' );
        }
      } else {
        node.src = node.getAttribute( 'data-src' );
      }
      break;
    }
    case 'VIDEO': {
      let source = node.getElementsByTagName( 'SOURCE' )[ 0 ];
      source.src = source.getAttribute( 'data-src' );
      break;
    }
    default: {
      node.src = node.getAttribute( 'data-src' );
    }
    }
    node.classList.remove( 'lozad' );
  }

  onIntersect( entries, observer ) {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        this.setActive( entry.target );
        if ( entry.target.tagName === 'VIDEO' || entry.target.tagName === 'IFRAME' ) {
          entry.target.load();
        }
        observer.unobserve( entry.target );
      }
    });
  }

  setObserver() {
    let options = {
      root: null,
      rootMargin: '800px',
      threshold: 0
    };
    this.lazyloads.forEach(( lazyload ) => {
      let observer = new IntersectionObserver( this.onIntersect.bind( this ), options );
      observer.observe( lazyload );
      this.observers.push( observer );
    });
  }
}
